import React from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../actions/AccountingActions';
import loaderGif from '../../styles/images/loader.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

class Modal extends React.Component {
    render() {
        const { closeModal, invoiceUrl, documents, loadingDocuments } = this.props;

        const title = invoiceUrl ? 'INVOICE' : (documents ? 'DOCUMENTS' : '');

        const loaderStyle = {
            backgroundImage: `url(${loaderGif})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            height: 700
        };

        return (
            <div
                id="invoice-modal"
                className="modal fade"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
                data-backdrop="static"
                data-keyboard="false">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => closeModal()}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {
                                invoiceUrl ?
                                    <iframe src={invoiceUrl} title="Invoice" style={invoiceUrl.includes('pdf') ? loaderStyle : {}} />
                                    :
                                    (documents ?
                                        <ul>
                                            {
                                                documents.map(doc =>
                                                    <li key={doc.name} className="mb-2">
                                                        <a href={doc.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: 16 }}>
                                                            {doc.name}
                                                            <FontAwesomeIcon icon={faExternalLinkAlt} className="ml-2"></FontAwesomeIcon>
                                                        </a>
                                                    </li>)
                                            }
                                        </ul>
                                        :
                                        (
                                            loadingDocuments ?
                                                <div style={loaderStyle}></div>
                                                :
                                                <h3>No documents to show.</h3>
                                        )
                                    )
                            }
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                                onClick={() => closeModal()}>
                                <span>Close</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { invoiceUrl, documents, loadingDocuments } = state.accountingData;
    return { invoiceUrl, documents, loadingDocuments };
};

const mapDispatchToProps = dispatch => {
    return {
        closeModal: () => dispatch(closeModal())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);


// WEBPACK FOOTER //
// ./src/view/Accounting/Modal.js